import { WritableSignal } from '@angular/core';
import { z } from 'zod';

export interface IIqLinksBlogStateService {
    getArticles: (num: number) => WritableSignal<IIqLinksBlogArticle[]>;
}

const IqLinksBlogArticleSchema = z.object({
    id: z.string(),
    name: z.string(),
    date: z.string(),
    url: z.string(),
    description: z.string(),
});
export type IIqLinksBlogArticle = z.infer<typeof IqLinksBlogArticleSchema>;

const IqLinksBlogSearchCriteriaInputSchema = z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
});
export type IIqLinksBlogSearchCriteriaInput = z.infer<
    typeof IqLinksBlogSearchCriteriaInputSchema
>;

export const BLOG_SEARCH_CRITERIA: IIqLinksBlogSearchCriteriaInput = {
    firstName: 'Dean',
    lastName: 'Croke',
};

export const DATE_FORMAT = 'MMM d, y, h:mm a'